import { toast } from "react-toastify";
import CustomButton from "../components/ReUsableComponents/CustomButton";
import { BiX } from "react-icons/bi";

export const next = (nexxtClickHandler:any,isNextDisabled?:boolean) => {
    return (
      <div>
        <CustomButton
          name="Next"
          onClickHandler={nexxtClickHandler}
          font="font-bold transition duration-700 ease-in-out active:underline active:bg-secondaryColor active:opacity-50"
          py="py-2 px-5"
          round="full"
          text="text-sm"
          disabled={isNextDisabled}
        />
      </div>
    );
  };
  
export const generateUniqueKey = () => {
  return Math.random().toString(36).slice(2, 11); // Using slice() instead of substr()
}

export const showSuccessToast = (message: string, icon: React.ReactNode) => {
  toast(
    ({ closeToast }) => (
      <div
        className="flex items-center justify-between gap-3 px-3 py-2 font-gully border-2 border-satPrepGreen rounded-md bg-white w-full"
        style={{ boxShadow: "0px 4px 8px 0px rgba(28, 37, 44, 0.08)" }}
      >
        {icon}
        <p className="font-gully text-satPrepBlack text-lg">{message}</p>
        <button onClick={closeToast} className="text-xl hover:text-gray-500">
          <BiX />
        </button>
      </div>
    ),
    {
      closeButton: false,
      hideProgressBar: true,
      autoClose: 3000,
      position: "top-right",
      className: "max-w-[400px] w-full mx-4",
      style: {
        padding: 0,
        background: "transparent",
        boxShadow: "none",
      },
    }
  );
};